<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <re-app-update-modal />
  <re-pwa-install-modal />
  <re-cookie-banner />
  <div id="photoviewer-container"></div>
</ion-app>
